import { render, staticRenderFns } from "./BoolIcon.vue?vue&type=template&id=bbec1288"
import script from "./BoolIcon.vue?vue&type=script&lang=ts"
export * from "./BoolIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports